




































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import AbpBase from '@/lib/abpbase';
import * as proxy from '@/lib/service-proxies/service-proxies';
import AppConsts from '@/lib/appconst';
import PagedFilterAndSortedRequest from '@/store/entities/page-request';
import pagelist from '@/components/pagelistcomponent';
import edit from "./EditStorageQueryProductChannel.vue";
@Component({
  components: {edit}
})
export default class storagequeryproductchannelmanage extends pagelist {
    get prox() {
    return new proxy.StorageQueryProductChannelServiceProxy();
  }
  input :proxy.StorageQueryProductChannelPageInputDto = new proxy.StorageQueryProductChannelPageInputDto();
  createOrEditShow = false;
  sub_id = 0;
  createrange = [];
  columns = [
    {
      type: 'selection',
      width: 60,
      align: 'center'
    },
    {
      title: '名称',
      key: 'name'
    },
    {
      title:'操作',
      slot:'oper',
      fixed:'right',
      width:150
    }
  ];
  fetchDataList(
    request: PagedFilterAndSortedRequest,
    pageNumber: number,
    finishedCallback: Function
  ): void {
    this.input.skipCount = request.skipCount;
    this.input.maxResultCount = request.maxResultCount;
    this.input.sorting = request.sorting;
    this.prox.queryModelList(this.input).then(x => {
      this.dataList= x.items;
      this.showPaging(x);
    });
  }
  create() {
    this.createOrEditShow = true;
    this.sub_id = undefined;
  }
  del(row){
    this.$Modal.confirm({
      title: "你确定要删除吗?删除后将无法恢复",
      onOk: () => {
        this.prox.deletes([row.id]).then(() => {
          this.$Notice.success({ title: "删除成功" });
          this.getpage();
        });
      },
    });
  }
  
  getpage() {
    this.OnInit();
  }
  edit(row){
    // console.log(row);
    if (!row) {
      if (this.selectedDataItems.length == 0) {
        this.$Notice.error({ title: "请选中一条数据" });
        return;
      }
      row = this.selectedDataItems[0];
    }
    this.sub_id = row.id;
    this.createOrEditShow = true;
  }
  async created() {
    // this.createrange = [
    //   new Date(new Date(new Date().toLocaleDateString()).getTime()),
    //   new Date(new Date(new Date().toLocaleDateString()).getTime() + 86400000),
    // ];
    this.getpage();
  }
}
